/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import * as API from "../../framework/API/api";
import { EditPageHeader } from '../../components/EditPageHeader';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { BROAD_CAST_TYPE, ENTITYNAME, PLATFORMTYPE, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import moment from "moment";
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import ContractCollectionSelection from './ContractCollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';

export const SyndicateRightEditForm = (props) => {
    const blankDataItem = {
        ...props?.data,
        Licensor: props?.data?.Licensor ?? {},
        BroadcastMedium: props?.data?.BroadcastMedium ??
        {
            _id: BROAD_CAST_TYPE.Linear,
            Description: utility.getKeyByValue(
                BROAD_CAST_TYPE,
                BROAD_CAST_TYPE.Linear
            )
        },

        StartDate: props?.data?.StartDate ? moment(new Date(props.data.StartDate)).format('YYYY-MM-DD') : '',
        EndDate: props?.data?.EndDate ? moment(new Date(props.data.EndDate)).format('YYYY-MM-DD') : '',
        ExclusiveStartDate: props?.data?.ExclusiveStartDate ? moment(new Date(props.data.ExclusiveStartDate)).utc().format('YYYY-MM-DD') : '',
        ExclusiveEndDate: props?.data?.ExclusiveEndDate ? moment(new Date(props.data.ExclusiveEndDate)).utc().format('YYYY-MM-DD') : '',
        BlackoutStartDate: props?.data?.BlackoutStartDate ? moment(new Date(props.data.BlackoutStartDate)).format('YYYY-MM-DD') : '',
        BlackoutEndDate: props?.data?.BlackoutEndDate ? moment(new Date(props.data.BlackoutEndDate)).utc().format('YYYY-MM-DD') : '',
        Amount: props?.data?.Amount ?? 0,
        Currency: props?.data?.Currency ?? {},
        Exhibitions: props?.data?.Exhibitions ?? 0,
        Repeats: props?.data?.Repeats ?? 0,
        PlayTimeNumber: props?.data?.PlayTimeNumber ?? 0,
        PlayTime: props?.data?.PlayTime ?? {},
    };
    const [dataItem, setDataItem] = useState(blankDataItem)
    const [licensor, setLicensor] = useState([]);
    const [playTime, setPlayTime] = useState([]);
    const [platform, setPlatform] = useState([]);
    const [currency, setCurrency] = useState([]);

    const lang = useTranslation();

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let licensorRes = await API.getDataLookup(ENTITYNAME.Licensor, { sort: { Description: 1 } });
        setLicensor(licensorRes.data);
        var playTimeRes = await API.getDataLookup(ENTITYNAME.PlayTime, { sort: { Description: 1 } });
        setPlayTime(playTimeRes.data);
        var platform = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
        setPlatform(platform.data);
        var currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
        setCurrency(currencyRes.data);
    }
    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, [e.target.name]: !dataItem[e.target.name] });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (!dataItem.Licensor || Object.keys(dataItem.Licensor).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_licensor_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItem.StartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_start_date });
            return false;
        }
        if (!utility.isValidDate(dataItem.EndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_end_date });
            return false;
        }
        if (dataItem.StartDate >= dataItem.EndDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.end_date_should_be_greater_than_start_date_error_message });
            return false;
        }
        if (dataItem.Exhibitions < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.exhibition_should_not_be_zero_error_message });
            return false;
        }
        if (dataItem.Repeats < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.repeat_should_not_be_zero_error_message });
            return false;
        }
        if (Object.keys(dataItem.PlayTime).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_play_time_error_message });
            return false;
        }
        if (dataItem.PlayTimeNumber < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.play_time_number_should_not_be_zero_error_message });
            return false;
        }

        return true;
    }

    const onSave = () => {
        if (isValid()) {
            const data = {
                ...dataItem,
                Licensor: {
                    _id: dataItem.Licensor._id,
                    SID: dataItem.Licensor.SID,
                    Name: dataItem.Licensor.Name
                },
                BroadcastMedium: dataItem?.BroadcastMedium && Object.keys(dataItem?.BroadcastMedium).length > 0 ? {
                    _id: dataItem?.BroadcastMedium?._id,
                    Description: dataItem?.BroadcastMedium?.Description
                } : {},
                StartDate: (new Date(dataItem.StartDate)).getTime(),
                EndDate: (new Date(dataItem.EndDate)).getTime(),
                ExclusiveStartDate: dataItem.ExclusiveStartDate ? (new Date(dataItem.ExclusiveStartDate)).getTime() : 0,
                ExclusiveEndDate: dataItem.ExclusiveEndDate ? (new Date(dataItem.ExclusiveEndDate)).getTime() : 0,
                BlackoutStartDate: dataItem.BlackoutStartDate ? (new Date(dataItem.BlackoutStartDate)).getTime() : 0,
                BlackoutEndDate: dataItem.BlackoutEndDate ? (new Date(dataItem.BlackoutEndDate)).getTime() : 0,
                Amount: dataItem?.Amount === "" ? 0 : parseFloat(dataItem?.Amount ?? 0),
                Currency: dataItem?.Currency && Object.keys(dataItem?.PlayTime).length > 0 ? {
                    _id: dataItem.Currency._id,
                    SID: dataItem.Currency.SID,
                    Description: dataItem.Currency.Description
                } : {},
                Exhibitions: parseInt(dataItem.Exhibitions ?? 0),
                Repeats: parseInt(dataItem.Repeats ?? 0),
                PlayTime: dataItem?.PlayTime && Object.keys(dataItem?.PlayTime).length > 0 ?
                    { _id: dataItem.PlayTime._id, SID: dataItem.PlayTime.SID, Description: dataItem.PlayTime.Description } : {},
                PlayTimeNumber: parseInt(dataItem.PlayTimeNumber ?? 0),
            }
            console.log(data);
            props.saveEditData(data);
            props.onCancel();
        }
    }

    return (
        <>
            <BossDialog title={`${lang.add_syndicate_right_label}`} onClose={props.onCancel} width={"800px"}>
                <div className="row">
                    <div className="col-12">
                        <EditPageHeader showTitle={false} onSubmit={onSave} onCancel={props.onCancel} />
                        <div className="row mt-2">
                            <div className='col-6'>
                                <label>{lang.licensor_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white"}}
                                    data={licensor}
                                    name="Licensor"
                                    textField="Name"
                                    dataItemKey="_id"
                                    value={dataItem.Licensor}
                                    onChange={onChange}
                                    validator={(value) => value ? "" : "Please select the value"}
                                />

                            </div>
                            <div className='col-6'>
                                <label>{lang.broadcast_medium_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={Object.keys(BROAD_CAST_TYPE).map((key) => ({ _id: BROAD_CAST_TYPE[key], Description: key }))}
                                    name="BroadcastMedium"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.BroadcastMedium}
                                    onChange={onChange}
                                />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="">{lang.start_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="StartDate" value={dataItem.StartDate} onChange={(e) => onChange(e)} />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="">{lang.end_Date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="EndDate" value={dataItem.EndDate} onChange={(e) => onChange(e)} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-6">
                                <label htmlFor="">{lang.exclusive_start_date_label}</label>
                                <input type={'date'} name="ExclusiveStartDate" value={dataItem.ExclusiveStartDate} onChange={onChange} max={dataItem.ExclusiveEndDate} className="form-control-sm"
                                    style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.exclusive_start_date_label}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="">{lang.exclusive_end_date_label}</label>
                                <input type={'date'} name="ExclusiveEndDate" onChange={onChange} value={dataItem.ExclusiveEndDate} min={dataItem.ExclusiveStartDate} className="form-control-sm"
                                    style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.exclusive_end_date_label}
                                />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-6">
                                <label htmlFor="">{lang.blackout_start_date_label}</label>
                                <input type={'date'} name="BlackoutStartDate" value={dataItem.BlackoutStartDate} onChange={onChange} max={dataItem.BlackoutEndDate} className="form-control-sm"
                                    style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.blackout_start_date_label}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="">{lang.blackout_end_date_label}</label>
                                <input type={'date'} name="BlackoutEndDate" onChange={onChange} value={dataItem.BlackoutEndDate} min={dataItem.BlackoutStartDate} className="form-control-sm"
                                    style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.blackout_end_date_label}
                                />
                            </div>
                        </div>
                        <div className='row mt-2 mb-2'>
                            <div className="col-3">
                                <label htmlFor="">{lang.amount_label}</label>
                                <input type="number" className="form-control form-control-sm" name="Amount" value={dataItem.Amount} onChange={(e) => onChange(e)} min={0} />
                            </div>
                            <div className="col-3">
                                <label htmlFor="">{lang.currency_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={currency}
                                    name="Currency"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Currency}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="">{lang.exhibition_label} *</label>
                                    <input type="Number" className="form-control form-control-sm" name="Exhibitions" value={dataItem.Exhibitions} onChange={onChange} min="0" required />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="">{lang.repeat_label} *</label>
                                    <input type="Number" className="form-control form-control-sm" name="Repeats" value={dataItem.Repeats} onChange={onChange} min="0" required />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="TabView">{lang.playTime_label} *</label>
                                    <DropDownList style={{ backgroundColor: "white"}}
                                        data={playTime}
                                        name="PlayTime"
                                        textField="Description"
                                        dataItemKey="_id"
                                        value={dataItem.PlayTime}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="">{lang.play_time_number_label} *</label>
                                    <input type="Number" className="form-control form-control-sm" name="PlayTimeNumber" value={dataItem.PlayTimeNumber} onChange={onChange} min="0" required />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog>
        </>
    )
}
